/**
 * Frontend config for the Talking Avatar flow's preview-pair model picker.
 * Mirrors the Baseball Trend pattern: the picker lives in the bottom bar
 * and only affects the Stage-1 preview-pair images (NOT the Stage-2 Kling
 * Avatar video render).
 */

import type { TalkingAvatarImageModelId } from "@shared/schemas/api";

export type { TalkingAvatarImageModelId };

/** Image model used for the Stage-1 preview pair. Nano Banana 2 is the only
 *  model surfaced for this flow — it gives better results on face-driven
 *  previews than GPT Image 2. No picker in the UI. */
export const TALKING_AVATAR_IMAGE_MODEL_IDS: ReadonlyArray<TalkingAvatarImageModelId> = [
  "nano-banana-2",
];

export const TALKING_AVATAR_DEFAULT_IMAGE_MODEL_ID: TalkingAvatarImageModelId =
  "nano-banana-2";

/** How many previews we render per "preview" call. Mirrors the server's
 *  `PREVIEW_COUNT` constant. The preview-pair credit cost is read live from
 *  the `credit_costs` table in `useTalkingAvatar.ts` via `useCreditCosts()`
 *  (the exact row the server charges from) — never mirrored here. */
export const TALKING_AVATAR_PREVIEW_COUNT = 2;
